import { IGroupedLiveRecord } from '@sdk/contracts';
import { Button } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { LiveRecordItem } from '../LiveRecordItem';

import { LoadMoreWrapper } from './SectionRecordings.styles';

const ITEMS_PER_PAGE = 20;

interface SectionRecordingsProps {
  recordings: IGroupedLiveRecord[];
}

export const SectionRecordings: React.FC<SectionRecordingsProps> = ({ recordings }) => {
  const { t } = useTranslation('StudentCourseSummaryTranslations');
  const [visibleCount, setVisibleCount] = useState(ITEMS_PER_PAGE);

  const flatRecords = recordings.flatMap(({ event, records }) =>
    records.map(record => ({ event, record }))
  );

  const visibleRecords = flatRecords.slice(0, visibleCount);
  const remainingCount = flatRecords.length - visibleCount;
  const hasMore = remainingCount > 0;

  const handleLoadMore = () => setVisibleCount(prev => prev + ITEMS_PER_PAGE);

  return (
    <>
      {visibleRecords.map(({ event, record }) => (
        <LiveRecordItem key={record._id} recording={record} event={event} />
      ))}
      {hasMore && (
        <LoadMoreWrapper>
          <Button type="link" onClick={handleLoadMore}>
            {t('LOAD_MORE_RECORDS', { count: remainingCount })}
          </Button>
        </LoadMoreWrapper>
      )}
    </>
  );
};
